import React from "react";
import { Link } from "react-router-dom";

const JobBoardSection = () => {
    // Job categories from the image
    const jobCategories = [
        { name: "Clinical Medicine", slug: "clinical-medicine" },
        { name: "Medical Education", slug: "medical-education" },
        { name: "Medical communication", slug: "medical-communication" },
        { name: "Pharmaceuticals", slug: "pharmaceuticals" },
        { name: "Clinical research", slug: "clinical-research" },
        { name: "HealthTech", slug: "healthtech" },
        { name: "Business consulting", slug: "business-consulting" },
        { name: "Entrepreneurship", slug: "entrepreneurship" },
        { name: "Policy/legal/ethics", slug: "policy-legal-ethics" },
        { name: "Marketing/Sales", slug: "marketing-sales" },
        { name: "Creative", slug: "creative" },
        { name: "Wellness/lifestyle", slug: "wellness-lifestyle" },
    ];

    return (
        <>
        <style>{`
            @media (max-width: 768px) {
                .job-board-section {
                    padding-top: 2rem !important;
                }
                .job-board-heading {
                    font-size: 24px !important;
                }
            }
        `}</style>
        <section className="bg-gray-100 py-16 job-board-section">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-5xl font-bold mb-6 job-board-heading">Explore our Job Board</h2>
                <p className="text-lg mb-10 max-w-3xl mx-auto">
                    Upload your CV and receive instant, actionable feedback. Tailored for medical professionals, our analyser identifies 
                    weak points, gaps, and misalignments, then recommends improvements based on your specialty and goals.
                </p>

                <div className="mb-10">
                    <Link 
                        to="/signup" 
                        className="bg-black text-white px-8 py-3 rounded-full font-medium hover:bg-gray-800 transition-colors"
                    >
                        View all jobs
                    </Link>
                </div>

                <div className="flex flex-wrap justify-center gap-2 md:gap-3 max-w-4xl mx-auto">
                    {jobCategories.map((category, index) => (
                        <span
                            key={index}
                            className={`category-pill ${category.name ? category.name.toLowerCase().replace(/\s+|\//g, '-').replace(/[^a-z0-9-]/g, '') : ''}`}
                            style={{ cursor: 'default', pointerEvents: 'none' }}
                        >
                            {category.name}
                        </span>
                    ))}
                </div>
            </div>
        </section>
        </>
    );
};

export default JobBoardSection; 